import React, { useCallback } from 'react';
import cn from 'classnames';

import { isMobile } from 'app-constants';
import checkDesk from 'assets/svg/check.svg';
import chevron from 'assets/svg/chevron.svg';
import Icon from '../Icon';
import './CheckBox.scss';

const check = isMobile ? chevron : checkDesk;

interface Props {
    checked?: boolean;
    reversed?: boolean;
    onChange?: (event: React.SyntheticEvent) => void;
}

const CheckBox: React.FC<Props> = ({
    checked = false,
    reversed = false,
    onChange,
}) => {
    const handleCheckedChange = useCallback(
        (event: React.SyntheticEvent) => {
            if (!onChange) return;

            onChange(event);
        },
        [onChange]
    );

    return (
        <div
            className="__app-CheckBox-container"
            styleName={cn('container', {
                checked,
                reversed,
            })}
            onClick={handleCheckedChange}
        >
            {checked && <Icon styleName="icon" glyph={check} />}
        </div>
    );
};

export default CheckBox;
